import { cn } from "@/lib/utils";
import { EditIcon } from "@/components/assets/assets";
import { formatDateSmart } from "@/utils/date-formatter";
import { RenameModal } from "@/components/common/rename-modal";
import { TruncatedText } from "@/components/common/truncated-text";
import { IconButton } from "@/components/common/icon-button";
import { AudioPlayButton } from "@/components/common/audio-play-button";
import { useTranslation } from "react-i18next";
import { TextEditable } from "../common/text-editable";
import { useState } from "react";
import { MinusCircleIcon } from "../agent-creation/assets/minus-circle-icon";
import { DeleteConfirmModal } from "../ui/modal";

interface VoiceCardProps {
  audio: Audio;
  width?: string;
  height?: string;
  className?: string;
  showEdit?: boolean;
  showRemove?: boolean;
  onRename?: (name: string) => void;
  onRemove?: (id: string) => void;
}

/** 配音卡片 */
export const VoiceCard = ({
  audio,
  width,
  height,
  className,
  showEdit = true,
  showRemove,
  onRename,
  onRemove,
}: VoiceCardProps) => {
  // 为每个卡片添加独立的编辑状态
  const [isEditing, setIsEditing] = useState(false);
  const { t } = useTranslation();

  const handleRename = (name: string) => {
    if (!showEdit) return;
    setIsEditing(false);
    onRename?.(name);
  };

  return (
    <div
      className={cn(
        "group relative h-[76px] w-full flex items-center gap-4 p-5 rounded-xl border border-[#eaecf0] bg-white hover:border-[#667085] transition-border-color overflow-hidden",
        className
      )}
      style={{
        width,
        height,
      }}
    >
      <AudioPlayButton
        key={audio.id}
        iconClassName="w-9 h-9"
        disabled={!audio.audioUrl}
        url={audio.audioUrl}
      />
      <div className="flex flex-col gap-1 w-full relative">
        <div className="flex flex-col  gap-0.5 ">
          <TextEditable
            className="text-base font-medium max-w-[70%] truncate pl-0 overflow-hidden "
            value={audio.name}
            onChange={(name) => handleRename(name)}
            isEditing={isEditing}
            onStartEditing={showEdit ? () => setIsEditing(true) : undefined}
            // 确保编辑结束时更新状态
            onEndEditing={showEdit ? () => setIsEditing(false) : undefined}
            mode="doubleClick"
          />
          <p className="text-xs text-[#667085]">
            {formatDateSmart(audio.createdAt).replace("Today", t("creation_folder.project_card.today"))}
          </p>
        </div>
      </div>
      {showEdit && <IconButton
        className="absolute top-4 right-4"
        icon={<EditIcon className="w-5 h-5 cursor-pointer" />}
        onClick={(e) => {
          e.stopPropagation();
          setIsEditing(true);
        }}
      />}
      {showRemove && (
        <DeleteConfirmModal
          trigger={
            <IconButton
              className="absolute top-3 right-4 size-7 opacity-0 group-hover:opacity-100 transition-opacity"
              icon={<MinusCircleIcon className="w-5 h-5 cursor-pointer" />}
            />
          }
          onConfirm={() => onRemove?.(audio.id)}
        />
      )}
    </div>
  );
};
